const API_URL = process.env.REACT_APP_API_URL || '';

class CompetitorAnalysisCapability {
  constructor(planStateSetters, planGetters, savePlan) {
    this.setters = planStateSetters;
    this.getters = planGetters;
    this.savePlan = savePlan;
  }

  async updateCompetitorAnalysis(updates, planId) {
    if (!planId) {
      console.error("❌ No planId available for Competitor Analysis update");
      return { success: false, message: "No plan ID available" };
    }

    try {
      const token = localStorage.getItem('token');
      
      console.log(`📝 CompetitorAnalysisCapability: Updating Competitor Analysis for plan ${planId}:`, Object.keys(updates));
      
      const response = await fetch(
        `${API_URL}/api/competitor-analysis/plan/${planId}/update`,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updates)
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP ${response.status}`);
      }

      console.log('✅ Competitor Analysis update response:', data);
      return {
        success: true,
        message: `Updated ${data.fieldsUpdated?.join(', ')}`,
        updatedFields: data.fieldsUpdated,
        version: data.version
      };
    } catch (error) {
      console.error("❌ Error updating Competitor Analysis:", error);
      return { 
        success: false, 
        message: error.message 
      };
    }
  }

  async handleUpdateMarketIntelligence(data, action = null, context = {}) {
    console.log("🎯 CompetitorAnalysisCapability: Updating market intelligence", data);
    
    const marketIntelligence = data.marketIntelligence || data.market_intelligence || data.content;
    const planId = context.planId || this.getters?.currentPlanId || (typeof this.getters?.getCurrentPlanId === 'function' ? this.getters.getCurrentPlanId() : null);
    
    if (!marketIntelligence) {
      console.error("❌ No market intelligence data provided");
      return { success: false, message: "No market intelligence data provided" };
    }

    return this.updateCompetitorAnalysis({ marketIntelligence }, planId);
  }

  async handleUpdateOpportunityAnalysis(data, action = null, context = {}) {
    console.log("🎯 CompetitorAnalysisCapability: Updating opportunity analysis", data);
    
    const opportunityAnalysis = data.opportunityAnalysis || data.opportunity_analysis || data.content;
    const planId = context.planId || this.getters?.currentPlanId || (typeof this.getters?.getCurrentPlanId === 'function' ? this.getters.getCurrentPlanId() : null);
    
    if (!opportunityAnalysis) {
      console.error("❌ No opportunity analysis data provided");
      return { success: false, message: "No opportunity analysis data provided" };
    }

    return this.updateCompetitorAnalysis({ opportunityAnalysis }, planId);
  }

  async handleUpdateMethodology(data, action = null, context = {}) {
    console.log("🎯 CompetitorAnalysisCapability: Updating methodology", data);
    
    const methodology = data.methodology || data.content;
    const planId = context.planId || this.getters?.currentPlanId || (typeof this.getters?.getCurrentPlanId === 'function' ? this.getters.getCurrentPlanId() : null);
    
    if (!methodology) {
      console.error("❌ No methodology data provided");
      return { success: false, message: "No methodology data provided" };
    }

    return this.updateCompetitorAnalysis({ methodology }, planId);
  }
}

module.exports = CompetitorAnalysisCapability;
